import Iweb3 from 'web3'
import Istore from '@/store'
import Iusdt from "@/contract/USDT/interface"

// 合约区块链相关函数
export const block = {

    // 检查浏览器改在public/index中进行
    checkExpress() {
        let ok = ''
        if (navigator.userAgent.indexOf('Firefox') >= 0) {
            ok = 'Firefox'
        } else if (navigator.userAgent.indexOf('Opera') >= 0) {
            ok = 'Opera'
        } else if (navigator.userAgent.indexOf('Chrome') >= 0) {
            // edge同属Chrome内核
            ok = 'Chrome'
        }
        console.log('express:' + ok)
        if (ok === '') {
            // if (confirm('以太坊metamask不支持当前浏览器及移动设备 \n您可以使用chrome firefox opera brave \n不能正常访问google的用户可使用firefox\n详情可查看https://metamask.io')) {
            //   window.open('https://metamask.io')
            // }

            alert('不支持当前浏览器 \n您可以使用Edge, Chrome, Firefox, Opera, Brave, 360 \n并安装数字货币钱包, 推荐metamask\n详情可查看https://metamask.io')
        }
        return ok
    },

    // 添加代指定代币到钱包
    addToWallet(address, symbol, decimals) {
        // const image = 'https://dsports.one/img/icons/favicon-32x32.png' //代币图标
        window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
                type: 'ERC20',
                options: {
                    address,
                    symbol,
                    decimals,
                    // image
                }
            }
        })
    },

    addSLTToWallet() {
        const address= Istore.state.chain.BANK //代币地址
        const symbol = 'SLT' //代币名称(一般都是英文大写)
        const decimals = 18 //写死18
        // const image = 'https://dsports.one/img/icons/favicon-32x32.png' //代币图标
        window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
                type: 'ERC20',
                options: {
                    address,
                    symbol,
                    decimals,
                    // image
                }
            }
        })
    },

    //唤起钱包登录
    loginWallet() {
        console.log('loginWallet')
        return new Promise(function (resolve) {
            const metamaskProvider = window.ethereum
            metamaskProvider.request({method: 'eth_requestAccounts'}).then(accounts => {
                if (isStrEmpty(accounts)) {
                    console.log('invalid account')
                    resolve({IsError:false, message: 'invalid account'})
                } else {
                    Istore.state.wallet.account = accounts[0].toString()
                    Istore.state.wallet.chain = metamaskProvider.networkVersion.toString()

                    // // 设置chain
                    // 该方法中不能调用外部函数
                    // this.SetChainInfo(Istore.state.wallet.chain)
                    // // console.log('eth_requestAccounts wallet', Istore.state.wallet)
                    //
                    // // 重置帐号佘额
                    // if (!isStrEmpty(Istore.state.chain.Trading) && !isStrEmpty(Istore.state.wallet.account)) {
                    //     this.getUsdtBalanceOf(Istore.state.wallet.account)
                    //     this.getEthBalanceOf(Istore.state.wallet.account)
                    // }

                    // window.web3js.eth.getBalance(Istore.state.wallet.account)
                    //     .then(function (response) {
                    //         Istore.state.wallet.balance.eth = response.toString()
                    //     })
                    //     .catch(error => {
                    //         console.log('eth getBalance error', error)
                    //     })
                }

                resolve({IsError:false, message: Istore.state.wallet})
            })
                .catch(error => {
                    console.log('eth_requestAccounts error', error.message)
                    //如果用户拒绝了登录请求
                    if (error.message === "User rejected provider access") {
                        // 用户拒绝登录后执行语句；
                        console.log('User rejected provider access')
                        resolve({IsError:true, message: 'User rejected provider access'})
                    } else if (error.message === 'Already processing eth_requestAccounts. Please wait.') {
                        // 用户放置登录界面，没有登录
                        // {code: -32002, message: 'Already processing eth_requestAccounts. Please wait.'}
                        console.log('Already processing login run')

                        resolve({IsError:true, message: 'Already processing login run'})

                    } else {
                        // 其它情况
                        console.log("There was a problem signing you in wallet")
                    }
                })
        })
    },

    // 仅取当前metamask信息
    initWeb3() {
        console.log('init web3')

        // console.log('metamask', !window.ethereum, typeof window.ethereum === 'undefined', window.ethereum===undefined)
        if (typeof window.ethereum === 'undefined' || window.ethereum===undefined || !window.ethereum) {
            // alert('error.NotMetaMask')
            console.log('invalid wallet please install metamask')
            return false

        } else {

            window.web3js = new Iweb3(window.ethereum) // 全局web3js实例
            const metamaskProvider = window.ethereum
            // metamask网络切换自动刷新
            metamaskProvider.autoRefreshOnNetworkChange = false

            // 注册事件
            // reload on network change
            // networkChanged事件只有当你禁用ethereum.autoRefreshOnNetworkChange属性时才有用
            metamaskProvider.on('chainChanged', chain => {
                console.log('init web3 wallet chain changed to ', window.web3js.utils.hexToNumber(chain))
                // 当链改变时需重新加载链数据
                window.TradingAbi = null
                window.UsdtAbi = null
                const currentChain = window.web3js.utils.hexToNumber(chain).toString()
                this.SetChainInfo(currentChain)
                Istore.state.wallet.chain = currentChain

                // window.location.reload()
                // 如果钱包加锁则帐号为空
                if (isStrEmpty(Istore.state.wallet.account)) {
                    Istore.state.wallet.balance.usdt = 0
                    Istore.state.wallet.balance.eth = 0
                    return false
                }

                if (!isStrEmpty(Istore.state.chain.Trading) && !isStrEmpty(Istore.state.wallet.account)) {
                    this.getUsdtBalanceOf(Istore.state.wallet.account)
                    this.getEthBalanceOf(Istore.state.wallet.account)
                }

                // window.web3js.eth.getBalance(Istore.state.wallet.account)
                //     .then(function (response) {
                //         Istore.state.wallet.balance.eth = response.toString()
                //     })
                //     .catch(error => {
                //         Istore.state.wallet.balance.eth = 0
                //         console.log('eth getBalance error', error)
                //     })

            })
            // reload on account change
            metamaskProvider.on('accountsChanged', async accounts => {
                console.log('init web3 wallet account changed to ', accounts[0])

                // 当帐号更改时先设为初始值，重新取值
                Istore.state.wallet.balance.usdt = 0
                Istore.state.wallet.balance.eth = 0

                if (isStrEmpty(accounts[0])) {
                    console.log('wallet accounts changed invalid account')
                    Istore.state.wallet.account = ''
                    return false
                }

                // 取当前路由
                // console.log('router', router.currentRoute.value.fullPath)

                // window.location.reload()
                // 设置chain
                // this.SetChainInfo(metamaskProvider.networkVersion.toString())
                // 切换账号后重新取账号余额
                const currentAccount = accounts[0]
                // const currentChain = metamaskProvider.networkVersion.toString().trim()
                const currentChain = await window.web3js.eth.getChainId()
                // console.log('init web3 wallet account changed 2 ', currentAccount, currentChain)
                if (Istore.state.wallet.chain.toString() !== currentChain.toString()) {
                    this.SetChainInfo(currentChain.toString())
                    Istore.state.wallet.chain = currentChain.toString()
                }

                Istore.state.wallet.account = currentAccount.toString()
                // console.log('init web3 wallet account changed 3 ', Istore.state.wallet.account, Istore.state.wallet.chain)

                if (!isStrEmpty(Istore.state.chain.Trading) && !isStrEmpty(Istore.state.wallet.account)) {
                    this.getUsdtBalanceOf(Istore.state.wallet.account)
                    this.getEthBalanceOf(Istore.state.wallet.account)
                }

                // window.web3js.eth.getBalance(Istore.state.wallet.account)
                //     .then(function (response) {
                //         console.log('init web3 wallet account changed 4 ', response)
                //         Istore.state.wallet.balance.eth = response.toString()
                //     })
                //     .catch(error => {
                //         Istore.state.wallet.balance.eth = 0
                //         console.log('eth getBalance error', error)
                //     })

            })
        }
        return true
    },

    // 取我当前metamask账号的ETH余额
    getEthBalanceOf(fromAccount) {
        if (isStrEmpty(fromAccount)) {
            console.log('no from account')
            return 0
        }
        if (isStrEmpty(window.web3js)) {
            console.log('window web3js is null')
            this.initWeb3()
        }

        return new Promise(resolve => {
            window.web3js.eth.getBalance(fromAccount)
                .then(function (response) {
                    console.log('getEthBalance', response)
                    //如果是当前钱包账号 则更新余额
                    if (fromAccount === Istore.state.wallet.account) {
                        Istore.state.wallet.balance.eth = response.toString()
                    }
                    resolve(response.toString())
                })
                .catch(function(error){
                    console.log('eth getBalance error', error)
                    Istore.state.wallet.balance.eth = 0
                    resolve(0)
                })
        })
    },

    // 检查当前链是否为有效链,如果有效则设置合约数据，否则设空
    SetChainInfo(chainID) {
        console.log('SetChainInfo',chainID)
        // 重置链数据
        Istore.state.chain.ID= chainID.toString() // 无论当前链是否有合约都设置链ID
        Istore.state.chain.Type= ''
        Istore.state.chain.Name = ''
        Istore.state.chain.USDT = ''
        Istore.state.chain.Trading = '' // 是否有合约确定链是否有效

        for (let i=0; i<Istore.state.ValidChain.length; i++) {

            if (Istore.state.ValidChain[i].ID === chainID.toString()) {
                Istore.state.chain.Type= Istore.state.ValidChain[i].Type
                Istore.state.chain.ID= Istore.state.ValidChain[i].ID
                Istore.state.chain.Name= Istore.state.ValidChain[i].Name
                Istore.state.chain.USDT = Istore.state.ValidChain[i].USDT
                Istore.state.chain.Trading= Istore.state.ValidChain[i].Trading
            }
        }
        // console.log('SetChainInfo res',Istore.state.chain)
        return Istore.state.chain
    },

    // 仅检查当前链是否有效，不设置改变当前链
    GetChainInfo(chainID) {
        // console.log('getchaininfo', chainID,Istore.state.ValidChain.length)
        let reschain = ''
        for (let i=0; i<Istore.state.ValidChain.length; i++) {
            if (Istore.state.ValidChain[i].ID === chainID.toString()) {
                reschain = Istore.state.ValidChain[i]
            }
        }
        return reschain
    },

    // 取当前账号balance
    getUsdtBalanceOf(account) {
        console.log('getusdtbalance', account)
        if (isStrEmpty(Istore.state.chain.USDT)) {
            console.log('not usdt contract')
            return 0
        }

        if (isStrEmpty(window.UsdtAbi)) {
            // console.log('window.UsdtAbi is null')
            window.UsdtAbi = Iusdt.methods.init(Istore.state.chain.USDT)
        }

        window.UsdtAbi.methods.balanceOf(account).call()
            .then(function (response) {
                //如果是当前钱包账号 则更新余额
                if (account === Istore.state.wallet.account) {
                    Istore.state.wallet.balance.usdt = response.toString()
                }
                console.log('usdt balance:', Istore.state.wallet.balance.usdt)
            })
            .catch(function(error){
                console.log('usdt balance error', error)
            })
    },

    // 取当前账号balance
    getMutBalanceOf(account) {
        if (isStrEmpty(Istore.state.chain.USDT) || isStrEmpty(Istore.state.chain.BANK)) {
            console.log('not usdt contract')
            return
        }

        if (isStrEmpty(window.UsdtAbi)) {
            window.UsdtAbi = Iusdt.methods.init(Istore.state.chain.USDT)
        }
        window.UsdtAbi.methods.balanceOf(account).call()
            .then(function (response) {
                const reswei = window.web3js.utils.fromWei(response.toString(),'mwei')
                const resformat = Math.floor(reswei * 10000) / 10000
                //如果是当前钱包账号 则更新余额
                if (account === Istore.state.wallet.account) {
                    Istore.state.wallet.balance.usdt = {meta: response.toString(), format: resformat.toString()}
                }

                console.log('usdt balance:', Istore.state.wallet.balance.usdt.format)
            })
            .catch(function(error){
                console.log('usdt balance error', error)
                Istore.state.wallet.balance.usdt = {meta: '', format: ''}
            })

        window.bankabi.methods.balanceOf(account).call()
            .then(function (response) {
                const reswei = window.web3js.utils.fromWei(response.toString())
                const resformat = Math.floor(reswei * 10000) / 10000
                //如果是当前钱包账号 则更新余额
                if (account === Istore.state.wallet.account) {
                    Istore.state.wallet.balance.slt = {meta: response.toString(), format: resformat.toString()}
                }

                console.log('slt balance:', Istore.state.wallet.balance.slt)
            })
            .catch(function(error){
                console.log('slt balance error', error)
                Istore.state.wallet.balance.slt = {meta: '', format: ''}
            })
    },

    // 从当前from账号转出eth
    ETHTransfer(fromAccount, toAccount, sendValue) {
        // console.log('ETHTransfer',fromAccount,toAccount,sendValue)
        return new Promise(resolve => {
            window.web3js.eth.sendTransaction({
                from: fromAccount,
                to: toAccount,
                gasLimit: Istore.state.gasDef.middle,
                value: sendValue
            })
                .on("receipt", receipt => {
                    console.log('ETH Transfer receipt', receipt)
                    resolve(true)
                })
                .on('error', (error) => {
                    console.log('ETH Transfer error', error)
                    resolve(false)
                })
        })
    },

    // 签名转账从from账号转到to账号, 需提供账号密钥
   async ETHTransferSign(fromAccount, key, toAccount, sendValue) {

        const balance = await this.getEthBalanceOf(fromAccount)

        if (BigInt(balance)< BigInt(sendValue)) {
            console.log('Account balance is insufficient')
            return 'Account balance is insufficient'
        }

        return new Promise(resolve => {
            let rawTx = {
                from: fromAccount,
                to: toAccount,
                gas: Istore.state.gasDef.middle,
                value: sendValue,
            }
            // 用Key签名解锁账号
            window.web3js.eth.accounts.signTransaction(rawTx, key)
                .then((signedTx) => {
                    window.web3js.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction)
                        .on("receipt", receipt => {
                            console.log('ETHTransferSign receipt', receipt)
                            resolve('succeed')
                        })
                        .on('error', (err) => {
                            console.log('ETHTransferSign error', err)
                            resolve('ETHTransferSign error')
                        })

                })
                .catch(error=>{
                    console.log('ETH signTransaction error', error)
                    resolve('ETH signTransaction error')
                })
        })
    },

    async getBlock() {
        window.web3js = new Iweb3(window.ethereum) // 全局web3js实例
        const block = await window.web3js.eth.getBlock('latest')
        console.log('block info', block)
        // 可以根据block返回信息添加更多返回信息
        const res = {
            baseGas:block.baseFeePerGas,
            blockNumber:block.number,
            timestamp:block.timestamp
        }

        const block2 = await window.web3js.eth.getBlock(block.number - 240)
        console.log('block2', block2)

        return (res)
    },

    // 检查不同状态下的网络包连接，返回错误信息
    CheckNetwork(){
        let ErrorStr = '' // 描述 可用于提示用户
        let IsError = false // 是否有错
        let ErrorTitle = '' // 标题 例如 Warning,Error可用于提示框的标题

        if (isStrEmpty(Istore.state.wallet.account) || isStrEmpty(Istore.state.wallet.chain)){
            // 检查是否登录
            ErrorStr = 'Invalid account please login wallet'
            IsError = true
            ErrorTitle = 'Error'

        } else if (isStrEmpty(Istore.state.chain.Trading) || isStrEmpty(window.TradingAbi)){
            // 检查当前链是否部署合约
            ErrorStr = 'Invalid blockchain network'
            IsError = true
            ErrorTitle = 'Error'
        }
        return {IsError,ErrorTitle,ErrorStr}
    },
}

export function isStrEmpty(stringIn) {
    if ( stringIn===null || stringIn === undefined || stringIn === 'undefined' || typeof stringIn === 'undefined') {
        return true
    } else {
        if (stringIn.toString().trim() === '') {
            return true
        } else {
            return false
        }
    }
}

// 将时间戳转换为时间
export function formateTime(timestamp) {
    let time = timestamp.toString().trim()
    if (time.length === 10) {
        time = time * 1000
    }
    const current = new Date(parseInt(time.toString()))
    let month = current.getMonth() + 1
    let date = current.getDate()
    let hour = current.getHours()
    let min = current.getMinutes()
    let sec = current.getSeconds()
    let year = current.getFullYear()
    month = month < 10 ? '0' + month : month
    date = date < 10 ? '0' + date : date
    hour = hour < 10 ? '0' + hour : hour
    min = min < 10 ? '0' + min : min
    sec = sec < 10 ? '0' + sec : sec
    return year + '.' + month + '.' + date + ' ' + hour + ':' + min + ':' + sec
}

export function getJsonKeyByValue(jsonArray, value) {
    let key = ''
    jsonArray.forEach(function (v,i) {
        console.log('getJsonKeyByValue', v,i, value)
        // if (v==) {
        //     name = v.name;
        //     console.log(i);
        //     return;
        // }
    });
    return key;
}

// jsonArray数组排序，field任意键值，reverse是否为倒序
export function jsonSort(array, field, reverse) {

    //数组长度小于2 或 没有指定排序字段 或 不是json格式数据
    if (array.length < 2 || !field || typeof array[0] !== "object") return array;

    //字符串类型排序
    if (isNaN(array[0][field])) {
        array.sort(function (x, y) {
            return x[field].localeCompare(y[field])
        })
    } else {
        //数字类型排序
        array.sort(function (x, y) {
            return x[field] - y[field]
        })
    }

    //倒序为ture
    if (reverse) {
        array.reverse();
    }
    return array;
}

/**
 * 字串安指定长度位数前置补0
 * @param {string} str
 * @param {Integer} Digits
 * */
export function strCompletion(str, Digits) {
    console.log('parm', str, Digits)
    let diff =Digits - str.toString().length
    let completion = ''
    console.log('parm diff', diff)
    if (diff > 0) {
        for (let i = 0; i < diff; i++) {
            completion = completion + '0'
        }
    }

    return completion + str
}

/**
 * 字串安指定长度位数后补0
 * @param {string} str
 * @param {Integer} Digits
 * */
export function strCompletionRight(str, Digits) {
    let diff = Digits - str.toString().length
    let completion = ''
    if (diff > 0) {
        for (let i = 0; i < diff; i++) {
            completion = completion + '0'
        }
    }

    return str + completion
}

// 清除小数点尾部多余的的零,不改变值的大小，
// 123.3400=123.34
export function CleareEndZero(str) {
    let resStr = str.toString()
    if (resStr.indexOf('.') > 0) {
        let leng = resStr.length - 1
        while (resStr.substr(leng, 1) === '0') {
            resStr = resStr.substr(0, leng)
            leng--
        }
    }
    return resStr
}


/**
 * 复制
 * 复制的内容可在任意地方粘贴
 */
export function copyPaste(copyContext) {
    console.log('copy text', copyContext)
    let input = document.createElement("input") // 直接构建input
    input.value = copyContext // 设置内容
    document.body.appendChild(input) // 添加临时实例
    input.select() // 选择实例内容
    document.execCommand("Copy") // 执行复制
    document.body.removeChild(input)  // 删除临时实例
}

//暂停时间 sleep(1000); //闯入毫秒，如1秒，传递1000
export function sleep(d) {
    for (let t = Date.now(); Date.now() - t <= d;);
}

// 取两个数之间的随机整数
export function getRandom(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled); // 包含最小值和最大值
}




